import { Box, List, ListItem } from "@mui/material";
import Professionl_Picture from "../ProfilePic/Professional_Picture.jpg";

function About() {
  return (
    <Box>
      <Box
        sx={{
          width: '90vw',
          margin: "auto",
          marginTop:{lg:'75px',md:'75px',sm:'70px',xs:'70px'},
          marginBottom:'40px',
          textAlign: "justify",
          fontSize: "55px",
          color: "teal",
          boxSizing: "border-box",
        }}
      >
        About
        <hr/>
      </Box>
      <Box
        sx={{
          display: { lg: "grid", md: "grid", sm: "flex", xs: "flex" },
          backgroundColor: "black",
          width: { lg: "95vw" },
          margin: "auto",
          gridTemplateColumns: { lg: "8fr 1fr", md: "2fr 1fr" },
          flexDirection: {
            lg: "row",
            md: "row",
            sm: "column-reverse",
            xs: "column-reverse",
          },
          justifyContent: {
            lg: "space-between",
            md: "space-around",
            sm: "space-between",
            xs: "space-between",
          },
          color: "teal",
          gap: { lg: "100px", md: "50px", sm: "40px", xs: "40px" },
          fontSize: "23px",
          paddingBottom:"80px"
        }}
      >
        <Box sx={{ backgroundColor: "black" }}>
          <List
            sx={{
              listStyleType: "disc",
              pl: 2,
              marginLeft: { lg: "80px", md: "80px", sm: "50px", xs: "50px" },
              lineHeight: 1.75,
              "& .MuiListItem-root": {
                display: "list-item",
                color: "white",
              },
            }}
          >
            <ListItem>
              <Box sx={{ color: "#b0b0b0" }}>
                Hi, my name is Pranay Dnyaneshwar Khadse and I am from Wardha, Maharashtra.
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={{ color: "#b0b0b0" }}>
                I have completed my graduation in Mechanical Engineering from
                Bapurao Deshmukh College of Engineering, Sewagram. Later on, I joined Masai School for Full Stack Web Developement
                Course.
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={{ color: "#b0b0b0" }}>
                Now, I am a Full Stack Web Developer with a coding experiance of
                about 1200 Hrs along with a project building skills in a team as
                well as individually. I also learnt Communication Skills and Time Management during
                the course.
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={{ color: "#b0b0b0" }}>
                I believe in the concept of continuous learning by regularly
                upgrading my skills and enhancing my knowledge.
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={{ color: "#b0b0b0" }}>
                Looking for a challenging role in industry to utilize my skills
                and learn.
              </Box>
            </ListItem>
          </List>
        </Box>
        <Box
          component="img"
          src={Professionl_Picture}
          sx={{
            marginRight: { lg: "70px", md: "30px" },
            width: { lg: "450px", md: "350px", sm: "350px", xs: "75vw" },
            margin: { sm: "auto", xs: "auto" },
            borderRadius:'30px'
          }}
        ></Box>
      </Box>
    </Box>
  );
}

export default About;
